import { UseQueryResult } from '@tanstack/react-query';
import { memo, ReactElement } from 'react';
import { Box, CardMedia } from '@mui/material';
import { SessionImageDTO } from '../../../../api/generated';
import { DefaultErrorScreen, DefaultLoadingScreen } from '../../../ApiLoadingGuard';
import { ApiError } from '../../../ApiLoadingGuard/ApiLoadingGuard';

interface SelfServiceImageCardProps {
  imageQuery: UseQueryResult<SessionImageDTO, ApiError>;
}

export const SelfServiceImageCard = memo(function ({ imageQuery: image }: SelfServiceImageCardProps): ReactElement {
  const { isPending, isError, isEnabled, data } = image;

  const isNotAvailable = isError || (!isEnabled && !isPending);

  if (isNotAvailable) {
    return <DefaultErrorScreen defaultText={'error.imageNotAvailable'} iconSize='medium' />;
  }

  if (isPending) {
    return <DefaultLoadingScreen />;
  }

  return (
    <Box flex={1} minHeight={0} display='flex' alignItems='center' justifyContent='center'>
      <CardMedia
        component='img'
        src={data.imagePresignedUrl}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          maxHeight: '100%',
          borderRadius: '10px',
        }}
      />
    </Box>
  );
});
